






import { SimpleError } from '@simonbackx/simple-errors';
import { InputBox } from '@goodless/components'
import { Component, Prop,Vue, Watch } from 'vue-property-decorator';
import { ErrorBox, Validator } from '@simonbackx/simple-error-forms';

@Component({
    components: {
        InputBox
    }
})
export default class EmailInput extends Vue {
    @Prop({ default: '' })
    title: string;

    @Prop({ default: null })
    validator: Validator | null

    emailRaw = '';
    valid = true;

    @Prop({ default: null })
    value!: string | null

    @Prop({ default: true })
    required!: boolean

    @Prop({ default: '' })
    placeholder!: string

    errorBox: ErrorBox | null = null

    @Watch('value')
    onValueChanged(val: string | null) {
        if (val === null) {
            return
        }
        this.emailRaw = val
    }

    mounted() {
        if (this.validator) {
            this.validator.addValidation(this, () => {
                return this.validate()
            })
        }

        this.emailRaw = this.value ?? ''
    }

    destroyed() {
        if (this.validator) {
            this.validator.removeValidation(this)
        }
    }

    validate() {
        if (!this.required && this.emailRaw.length === 0) {
            this.errorBox = null

            if (this.value !== null) {
                this.$emit('input', null)
            }
            return true
        }

        const isValid = this.emailRaw.includes('@')

        if (!isValid) {
            this.errorBox = new ErrorBox(new SimpleError({
                'code': 'invalid_field',
                'message': 'Ongeldig e-mailadres',
                'field': 'email'
            }))

            if (this.required) {
                if (this.value !== '') {
                    this.$emit('input', '')
                }
            } else {
                if (this.value !== null) {
                    this.$emit('input', null)
                }
            }

            return false
        }
        this.$emit('input', this.emailRaw)

        this.errorBox = null
        return true
    }
}
